import React, { Component } from "react";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Menu,
  MenuItem
} from "@material-ui/core";
import MoreVertIcon from "@material-ui/icons/MoreVert";

class ShootsTable extends Component {
  render() {
    const anchorEl = this.state;
    const menu = (
      <Menu id="long-menu">
        <MenuItem>Disable</MenuItem>
        <MenuItem>Change Password</MenuItem>
        <MenuItem>Delete</MenuItem>
      </Menu>
    );
    return (
      <div>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Clinic Name</TableCell>
              <TableCell align="right">Address</TableCell>
              <TableCell align="right">Shoot Date</TableCell>
              <TableCell align="right">Status</TableCell>
              <TableCell align="right">Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>Hey</TableCell>
              <TableCell>Hey</TableCell>
              <TableCell>Hey</TableCell>
              <TableCell>Hey</TableCell>
              <TableCell>
                <IconButton aria-label="More" aria-haspopup="true">
                  <MoreVertIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
        {menu}
      </div>
    );
  }
}

export default ShootsTable;
